import { gql } from '@apollo/client';

export const CREATE_BOOKMARK = gql`
  mutation CreateBookmark($id: ID!, $adType: AdTypeEnum!) {
    createBookmark(input: { id: $id, adType: $adType }) {
      status
      bookmark {
        id
      }
    }
  }
`;

export const DELETE_BOOKMARK = gql`
  mutation DeleteBookmark($id: ID!, $adType: AdTypeEnum!) {
    deleteBookmark(input: { id: $id, adType: $adType }) {
      status
    }
  }
`;
